/** Partner portal nav — distinct from org admin sidebar. */

/**
 * Sidebar groups, in display order. Items with `section: "topbar"` (notifications and the inbox)
 * live in the header next to the account menu, so they are not repeated in the sidebar.
 */
export const PARTNER_NAV_SECTIONS = [
  { id: "overview", label: null },
  { id: "clients", label: "Clients" },
  { id: "earnings", label: "Earnings" },
  { id: "resources", label: "Resources" },
  { id: "support", label: "Account" },
];

export const PARTNER_NAV = [
  {
    id: "dashboard",
    label: "Dashboard",
    shortLabel: "Home",
    path: "/partner/dashboard",
    section: "overview",
  },
  {
    id: "notifications",
    label: "Notifications",
    shortLabel: "Alerts",
    path: "/partner/notifications",
    badgeKey: "unreadNotifications",
    section: "topbar",
  },
  {
    id: "clients",
    label: "Clients",
    shortLabel: "Clients",
    path: "/partner/clients",
    section: "clients",
    // Leads are clients the office has not activated yet; they live on a tab of this page.
    aliases: ["/partner/leads"],
  },
  {
    id: "documents",
    label: "Documents",
    shortLabel: "Docs",
    path: "/partner/documents",
    section: "clients",
  },
  { id: "tasks", label: "Tasks", shortLabel: "Tasks", path: "/partner/tasks", section: "clients" },
  {
    id: "appointments",
    label: "Appointments",
    shortLabel: "Appts",
    path: "/partner/appointments",
    section: "clients",
  },
  {
    id: "payments",
    label: "Referral payments",
    shortLabel: "Pay",
    path: "/partner/payments",
    section: "earnings",
  },
  {
    id: "price-list",
    label: "Price list",
    shortLabel: "Prices",
    path: "/partner/price-list",
    section: "resources",
  },
  {
    id: "check-list",
    label: "Check list",
    shortLabel: "Checks",
    path: "/partner/check-list",
    section: "resources",
  },
  {
    id: "courses",
    label: "Courses",
    shortLabel: "Courses",
    path: "/partner/courses",
    section: "resources",
  },
  {
    id: "training",
    label: "Training",
    shortLabel: "Train",
    path: "/partner/training",
    section: "resources",
  },
  {
    id: "alerts",
    label: "Messages",
    shortLabel: "Inbox",
    path: "/partner/alerts",
    badgeKey: "unreadAlerts",
    section: "topbar",
  },
  {
    id: "help",
    label: "Help & Support",
    shortLabel: "Help",
    path: "/partner/help",
    badgeKey: "unreadTickets",
    section: "support",
  },
  {
    id: "settings",
    label: "Settings",
    shortLabel: "Settings",
    path: "/partner/settings",
    section: "support",
  },
];

/** Sidebar items grouped by section, skipping the ones that live in the top bar. */
export const getSidebarSections = () =>
  PARTNER_NAV_SECTIONS.map((section) => ({
    ...section,
    items: PARTNER_NAV.filter((item) => item.section === section.id),
  })).filter((section) => section.items.length > 0);

/** Primary tabs on the mobile bottom bar (keep ≤4 + More). */
export const MOBILE_PRIMARY_NAV_IDS = ["dashboard", "clients", "appointments", "payments"];

export const getPartnerNavItem = (id) => PARTNER_NAV.find((item) => item.id === id);

/** The nav item whose path the current location sits under, for the header title. */
export const findActiveNavItem = (pathname = "") =>
  PARTNER_NAV.find((item) =>
    [item.path, ...(item.aliases || [])].some(
      (path) => pathname === path || pathname.startsWith(`${path}/`)
    )
  );

export const getMobilePrimaryNav = () =>
  MOBILE_PRIMARY_NAV_IDS.map(getPartnerNavItem).filter(Boolean);

export const getMobileMoreNav = () =>
  PARTNER_NAV.filter((item) => !MOBILE_PRIMARY_NAV_IDS.includes(item.id));

/** Tabs on a partner's client detail page — only what a partner may actually see. */
export const CLIENT_TABS = [
  { id: "details", label: "Details" },
  { id: "applications", label: "Applications" },
  { id: "documents", label: "Documents" },
  { id: "messages", label: "Messages" },
  { id: "commissions", label: "Commission" },
];
